import React, { useState, useEffect } from 'react';
import types from 'prop-types';

// PropTypes
// https://reactjs.org/docs/typechecking-with-proptypes.html#proptypes
Input.propTypes = {
  title: types.string,
  value: types.oneOfType([types.string, types.number]),
  setValue: types.any,
  placeholder: types.string,
  disabled: types.bool,
  label: types.string,
  fieldInfo: types.string,
  type: types.string,
  validate: types.func
};

// Default props
Input.defaultProps = {
  title: 'The Title',
  value: '',
  type: 'text',
  placeholder: ''
};

export function Input(props) {
  // Local state
  const [text, setText] = useState(props.value);

  useEffect(() => {
    if (props.value && props.value !== text) {
      setText(props.value);
    }
  }, [props.value, setText, text]);

  function handleChange(event) {
    let val = event.target.value;
    if (typeof props.validate === 'function') {
      if (props.validate(val)) {
        return
      }
    }
    setText(val);
    if (props.setValue) {
      props.setValue(val);
    }
  }
  let inp;
  let input = (
    <input
      className={'input'}
      type={props.type}
      value={text}
      placeholder={props.placeholder}
      disabled={props.disabled}
      onChange={handleChange}
    />
  );

  if (props.label) {
    inp = (
      <label>
        {props.label}
        {input}
      </label>
    );
  } else {
    inp = input;
  }

  // Render
  return <div className={'field-type-input'}>{inp}</div>;
}